import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cc392940"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "sc-upload-file"
};
const _hoisted_2 = {
  key: 0,
  class: "el-upload__tip"
};
const _hoisted_3 = {
  style: {
    "display": "none!important"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_upload, {
    disabled: $props.disabled,
    "auto-upload": $props.autoUpload,
    action: $props.action,
    name: $props.name,
    data: $props.data,
    "http-request": $options.request,
    "file-list": $data.defaultFileList,
    "onUpdate:fileList": _cache[0] || (_cache[0] = $event => $data.defaultFileList = $event),
    "show-file-list": $props.showFileList,
    drag: $props.drag,
    accept: $props.accept,
    multiple: $props.multiple,
    limit: $props.limit,
    "before-upload": $options.before,
    "on-success": $options.success,
    "on-error": $options.error,
    "on-preview": $options.handlePreview,
    "on-exceed": $options.handleExceed
  }, {
    tip: _withCtx(() => [$props.tip ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($props.tip), 1)) : _createCommentVNode("", true)]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createVNode(_component_el_button, {
      type: "primary",
      disabled: $props.disabled
    }, {
      default: _withCtx(() => [_createTextVNode("Click to upload")]),
      _: 1
    }, 8, ["disabled"])], true)]),
    _: 3
  }, 8, ["disabled", "auto-upload", "action", "name", "data", "http-request", "file-list", "show-file-list", "drag", "accept", "multiple", "limit", "before-upload", "on-success", "on-error", "on-preview", "on-exceed"]), _createElementVNode("span", _hoisted_3, [_createVNode(_component_el_input, {
    modelValue: $data.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.value = $event)
  }, null, 8, ["modelValue"])])]);
}